<template>
  <div>
    <div v-if="isFreeForMembers" class="text-green-600 font-bold text-lg">
      {{ t("trip_price.free_for_members") || "Free for Members" }}
    </div>
    <div v-else class="flex items-center gap-2">
      <span
        v-if="originalPrice && parseFloat(currentPrice) < parseFloat(originalPrice)"
        class="text-gray-400 line-through text-sm"
      >
        {{ originalPrice }} {{ t("tour_card.kd_person") || "KD" }}
      </span>
      <span class="font-medium" :class="priceClass">
        {{ currentPrice }} {{ t("tour_card.kd_person") || "KD" }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

const props = defineProps<{
  currentPrice: string;
  originalPrice?: string | null;
  isFreeForMembers?: boolean;
  priceClass?: string;
}>();

const priceClass = props.priceClass || "text-first";
</script>

